import { inject } from 'vue'
import { useLocale, t, setLocale as setI18nLocale, toggleLocale as toggleI18nLocale } from '../i18n/index.js'

export function useLanguage() {
  // Пробуем получить из provide, если нет - используем напрямую
  const i18n = inject('i18n', null)
  
  const locale = i18n?.locale || useLocale()

  const availableLocales = [
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'en', name: 'English', flag: '🇬🇧' }
  ]

  const setLocale = (newLocale) => {
    setI18nLocale(newLocale)
  }

  const toggleLocale = () => {
    toggleI18nLocale()
  }

  return {
    locale,
    availableLocales,
    setLocale,
    toggleLocale,
    t
  }
}

